import React from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { push } from 'redux-first-history';
import Button from '@starbucks-web/pattern-library/lib/components/button';
import { useModalContext } from '@starbucks-web/pattern-library/lib/components/modal-provider';

import { doLogin } from 'shared/app/shell';
import SharedBottomSheet from 'shared/app/components/bottom-sheet-with-messages';
import { sharedCallsToAction } from 'shared/app/messages/ctas';

import messages from './messages';

const giftPaymentHash = '#payment';
export const UNAUTH_GIFT_SHEET_TITLE_ID = 'UNAUTH_GIFT_SHEET_TITLE_ID';

const UnAuthBottomSheet = () => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const { closeModal } = useModalContext();

  const onSignin = () => {
    closeModal();
    // replace any existing hash with the hash of the
    // gift payment bottom sheet to construct a returnUrl
    const currentHash = window.location.hash;
    const returnUrl = window.location.href
      .replace(currentHash, '')
      .concat(giftPaymentHash);
    dispatch(doLogin({ returnUrl }));
  };

  const onContinue = () => {
    closeModal();
    dispatch(push(giftPaymentHash));
  };

  return (
    <SharedBottomSheet
      headingChildren={formatMessage(messages.heading)}
      headingProps={{
        id: UNAUTH_GIFT_SHEET_TITLE_ID,
      }}
    >
      <p className="my4">
        <Button
          className="mxn3 text-lg"
          data-e2e="signInButton"
          onClick={onSignin}
          visualStyle="textOnly"
        >
          {formatMessage(sharedCallsToAction.signin)}
        </Button>
      </p>
      <p>
        <Button
          className="mxn3 text-lg"
          data-e2e="continueAsGuestButton"
          onClick={onContinue}
          visualStyle="textOnly"
        >
          {formatMessage(messages.continueCta)}
        </Button>
      </p>
    </SharedBottomSheet>
  );
};

export default UnAuthBottomSheet;
